import { PHASE_ORDER } from "./system";
/**
 * Phase-ordered system dispatcher. The world owns one Scheduler. Every fixed
 * step calls `scheduler.step(dt, world)`, which iterates phases in fixed order
 * and runs each system's `step` in that phase.
 *
 * No per-React-component useFrame "system". If it ticks the simulation, it
 * lives here.
 */
export class Scheduler {
    byPhase = new Map();
    register(cls) {
        const instance = new cls();
        const phase = cls.phase;
        if (!phase)
            throw new Error(`system ${cls.name} missing static phase`);
        const list = this.byPhase.get(phase) ?? [];
        list.push(instance);
        this.byPhase.set(phase, list);
        return instance;
    }
    init(world) {
        for (const phase of PHASE_ORDER) {
            const list = this.byPhase.get(phase);
            if (!list)
                continue;
            for (const s of list)
                s.init(world);
        }
    }
    step(dt, world) {
        for (const phase of PHASE_ORDER) {
            const list = this.byPhase.get(phase);
            if (!list)
                continue;
            for (const s of list)
                s.step(dt, world);
        }
    }
    dispose() {
        for (const list of this.byPhase.values()) {
            for (const s of list)
                s.dispose();
        }
        this.byPhase.clear();
    }
}
